//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsSlottedDropdown } from "@nuskin/design-components";

/**
 * NsProductVariantSelector
 *
 * How to use:
 *
 * @event select  When a selection occurs this event emits a function with
 * params: (value, index)
 */

export default {
  name: "NsProductVariantSelector",
  components: { NsSlottedDropdown },
  props: {
    /**
     * Disables input
     */
    disabled: Boolean,
    /**
     * Label
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Sku of the current product
     */
    selectedSku: {
      type: String,
      default: ""
    },
    /**
     * The size of the selector.
     * @values large, small
     */
    size: {
      type: String,
      default: "large"
    },
    /**
     * Makes the component taller to match button height
     */
    tall: Boolean,
    /**
     * Array of variant skus
     */
    variantSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Array of variant options. Should be {id, sku, shade, label}
     */
    variants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    /**
     * Disables input
     */
    disable() {
      this.disabled = true;
    },
    /**
     * Enables input
     */
    enable() {
      this.disabled = false;
    },
    /**
     * Handle variant selection
     */
    handleSelect(value, index) {
      // if (!data.pristine && !this.settingVariants) {
      /**
       * Fired when a new variant is selected: function(value: string, index: number) => void
       *
       * @type {select}
       * @property {(string)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("select", value, index);
      // this.variantIndex = data.index;
      // }
    }
  }
};
